var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#90A9C0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "star_body",
    opacity: 0.142,
    d: "m10.706 13-.164-.972-.512-2.994 2.242-2.138.728-.694-1.013-.147-3.114-.459L7.46 2.884 7 2l-.46.884-1.413 2.712-3.114.459L1 6.202l.728.694L3.97 9.034l-.512 2.994-.164.972.908-.451L7 11.152l2.798 1.397.908.451z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "star_stroke",
    d: "m12.133 14-.205-1.237-.64-3.811 2.801-2.72.911-.884-1.266-.187-3.892-.584-1.767-3.452L7.5 0l-.575 1.125-1.767 3.452-3.892.584L0 5.348l.91.884 2.802 2.72-.64 3.81L2.867 14l1.136-.575L7.5 11.648l3.497 1.777 1.136.575Zm-1.681-2.269-2.657-1.355-.295-.147-.295.147-2.657 1.355.485-2.902.055-.319-.235-.23-2.131-2.063 2.957-.442.33-.05.15-.289L7.5 2.814l1.34 2.622.151.29.33.049 2.957.442-2.131 2.062-.235.231.055.32.485 2.901Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.33d47a05.svg";
export { ForwardRef as ReactComponent };